/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import {
    findColleagues,
    BASE_URL,
    SearchBookings_api,
    fetchWithTokenRefresh2,
    employeeRole_api,
    EmployeeRole_api
}
    from "../apiUtils";

import { useHistory } from "react-router-dom";
import Header from '../Header/HeaderNoDropdown'
import Sidebar from '../Sidebar/Sidebar'
import WhiteLocation from "../../assets/images/icons/white-location.svg"
import GreenLeader from "../../assets/images/icons/green-leader.svg"
import ListIcon from "../../assets/images/icons/list-icon.svg"
import NoData from "../../assets/images/icons/no-data-page.png"
import logo from "../../assets/images/logo-big.svg"

import orangestar from "../../assets/images/icons/orange-star.svg"
import notification from "../../assets/images/icons/notification.svg"
import profileImg from "../../assets/images/profileImg.jpg"
import edit from "../../assets/images/icons/edit.svg"
import logoutwhite from "../../assets/images/icons/logout-white.svg"
import Profile from "../../assets/images/profile.png"
import ProfileLocation from "../../assets/images/icons/profile-location.svg"
import FillStar from "../../assets/images/icons/fill-star.svg"
import GrayStar from "../../assets/images/icons/gray-star.svg"
import BlackClose from "../../assets/images/icons/black-close.svg"
import loadingGIF from "../../assets/images/loading.gif"

import { useTranslation } from 'react-i18next'
import NotificationPanel from '../Common/Notification'
import CustomSearchableCheckboxDropdownWithLable from '../Common/CustomSearchableCheckboxDropdownWithLable';
import CustomDropdownWithLable from '../Common/CustomDropdownWithLable';
import { Images } from '../Common/Images';
import CreditInfoCard from '../Common/CreditInfoCard';
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";
import { syncHasEmergencyRolesFromPayload } from "../../utils/SecurityService.js";

export default function EmployeeRoles({ userCredit, creditBalanceRefill }) {
    const { t, i18n } = useTranslation()
    const history = useHistory();
    
    const [isLoading, setIsLoading] = useState(false);
    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
    const [groups, setGroups] = useState([]);

    const [searchBookings, setSearchBookings] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const [zones, setZones] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [zoneDropdownOpen, setZoneDropdownOpen] = useState(false);
    const [selectedZoneIds, setSelectedZoneIds] = useState(null);

    const [creditBalanceRefillEvery, setCreditBalanceRefillEvery] = useState("");
    const [isThumbnailPresent, setIsThumbnailPresent] = useState(0);
    const [companyId, setCompanyId] = useState(0);
    const [creditBalance, setCreditBalance] = useState(0);
    const [zoneCreditValue, setZoneCreditValue] = useState(0);
    const expandedLogoUrl = companyId
        ? `https://ronlivestaging.s3.amazonaws.com/companylogo/${companyId}/logo.png`
        : "";

    const [selectedRoleId, setSelectedRoleId] = useState(0);
    const [selectedRole, setSelectedRole] = useState(null);
    const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);

    const getFirstName = () => localStorage.getItem("firstname");
    const zoneDropdownValue =
        selectedZoneIds === null && zones.length > 0
            ? zones.map((zone) => zone.Id)
            : selectedZoneIds;

    useEffect(() => {
        document.title = `${t("employee_roles")} | Ronspot`
      }, []);

    useEffect(() => {

        const fetchData = async () => {

            if (Array.isArray(selectedZoneIds) && selectedZoneIds.length === 0) {
                setSearchBookings([]);
                return;
            }

            setIsLoading(true);

            try {

                // ✅ Zone parameter
                const zoneIdString =
                    selectedZoneIds === null || selectedZoneIds.length === zones.length
                        ? "0"
                        : selectedZoneIds.join(",");

                // ✅ Role parameter (0 = All Roles)
                const roleIdParam = selectedRoleId || 0;

                const profileData = await employeeRole_api(
                    zoneIdString,
                    roleIdParam
                );
                const resolvedHasEmergencyRoles = syncHasEmergencyRolesFromPayload(profileData, {
                    defaultToVisibleOnMissing: true,
                });
                if (resolvedHasEmergencyRoles === 0) {
                    history.replace("/calendar");
                    return;
                }
                 handleApiUiResponse(profileData, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });
                const rec = profileData?.Data?.Records || {};
                setCreditBalanceRefillEvery(rec.CreditBalanceRefillEvery);
                setIsThumbnailPresent(rec.IsThumbnailPresent);
                setCompanyId(rec.CompanyId);
                setCreditBalance(rec.CreditBalance);
                setZoneCreditValue(rec.ZoneCreditValue || 0);
                // ✅ Roles dropdown
                setGroups(rec.EmployeeRoles || []);

                // ✅ Zones dropdown
                const zoneList = rec.ZoneList || [];
                setZones(zoneList);

                // ✅ Select ALL zones on first load
                let bookings = rec.EmployeeRoleBookings || [];

                console.log("Fetched EmployeeRoleBookings:", bookings);

                // ✅ Filter only if specific role selected
                if (selectedRoleId && selectedRoleId !== 0) {
                    bookings = bookings.filter(b =>
                        (b.EmployeeRoleIconList || []).some(
                            r => r.Id === selectedRoleId
                        )
                    );
                }

                // ✅ Group bookings by unique combination
                const grouped = Object.values(
                    bookings.reduce((acc, booking) => {

                        const key = `${booking.UserId}-${booking.BookingDate}-${booking.ZoneId}-${booking.SpotId}`;

                        if (!acc[key]) {
                            acc[key] = {
                                userId: booking.UserId,
                                name: booking.EmployeeFullName,
                                bookings: [],
                                roles: booking.EmployeeRoleIconList || []
                            };
                        }

                        acc[key].bookings.push(booking);

                        return acc;

                    }, {})
                );

                console.log("Grouped EmployeeRoleBookings:", grouped);

                // ✅ If no zones selected → clear data
                setSearchBookings(grouped);

            } catch (err) {

                console.error("Error fetching EmployeeRoles data:", err);

            } finally {

                setIsLoading(false);

            }

        };

        fetchData();

    }, [selectedZoneIds, selectedRoleId]);

    const handleRoleSelect = (role) => {

        if (!role) {
            setSelectedRole(null);
            setSelectedRoleId(0);
        } else {
            setSelectedRole(role);
            setSelectedRoleId(role.Id);
        }

        setIsDropdownOpen(false);
    };

    const GotoMapClick = (zoneId, bookingDateStr, mapType, mapExist) => {
        console.log("Map Click:", { zoneId, bookingDateStr, mapType, mapExist });

        if (mapType === 2 || mapType === 3) {

            history.push("/map", {
                selectedZoneId: zoneId,
                selectedDate: bookingDateStr,
                roleStatus: true
            });
        };
    }
    const getGuId = () => localStorage.getItem("guId");
    const headerTitle = t("react_hi").replace("%s", getFirstName());

    return (
        <div>
            <div className='content-area employee-roles-page'>
                {/* <Header /> */}
                <header className="header">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-3">
                                <div className="greeting-title">
                                    <p>{headerTitle}</p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-xl-9 offset-xl-3 col-lg-10 offset-lg-2">
                                        <div className="filter-panel d-flex justify-content-end align-items-center gap-3">
                                            <div className="filter-options d-flex gap-3 w-100">

                                                <div className="employee-list location-list">
                                                    <div className="dropdown form-input-container d-flex justify-content-center flex-column">
                                                        <CustomSearchableCheckboxDropdownWithLable
                                                            items={zones}
                                                            value={zoneDropdownValue}
                                                            labelKey="CarParkName"
                                                            valueKey="Id"
                                                            placeholder={`${t("select_a_zone")}`}
                                                            multiple={true}
                                                            searchable={false}
                                                            showSelectAll={true}
                                                            onChange={(vals) => {
                                                                if (vals.length === 0) {
                                                                    setSelectedZoneIds([]);
                                                                } else if (vals.length === zones.length) {
                                                                    setSelectedZoneIds(null);
                                                                } else {
                                                                    setSelectedZoneIds(vals);
                                                                }
                                                                setSearchBookings([]);
                                                            }}
                                                            label={t("zone")}
                                                            // rootClassName="employee-roles-zone-dropdown"
                                                            rootClassName="colleagues-zone-list"
                                                        />

                                                    </div>
                                                </div>
                                                <CustomDropdownWithLable
                                                    items={groups}
                                                    selectedItem={selectedRole}
                                                    label={t("roles")}
                                                    placeholder={t("all_roles")}
                                                    labelKey="Name"
                                                    valueKey="Id"
                                                    iconKey="IconImage"
                                                    allOptionLabel={t("all_roles")}
                                                    allOptionIcon={Images.AllRole}
                                                    noOptionsLabel={t("react_no_roles_available")}
                                                    searchable={true}
                                                    searchPlaceholder={t("search")}
                                                    onChange={handleRoleSelect}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="menu-bar-options d-flex justify-content-end gap-3">
                                    {zoneCreditValue !== 0 && (
                                    <CreditInfoCard
                                        userZoneCreditValue={zoneCreditValue}
                                        userZoneCreditBalance={creditBalance}
                                        creditBalanceRefillEvery={creditBalanceRefillEvery}
                                        IsThumbnailPresent={isThumbnailPresent}
                                        CompanyId={companyId}
                                    />
                                    )}
                                    <div className="notification-info">
                                        <a href="#" data-bs-toggle="offcanvas" data-bs-target="#notification-panel" aria-controls="notification-panel" className="position-relative notification-icon">
                                            <img src={notification} alt="" />{hasUnreadNotifications && (
                                                <span className="orange-dot"></span>
                                            )}</a>
                                    </div>
                                    <NotificationPanel onUnreadChange={setHasUnreadNotifications} />
                                    {/* <div className="profile-info">
                                <div className="dropdown dropdwon-green">
                                    <a href="#" className="profileImg" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><img src={profileImg} alt="" /></a>

                                    <ul className="dropdown-menu profile-dropdown" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <a className="dropdown-item" href="#"
                                            ><span className="withIcon"><img src={edit} alt="" /></span><span className="withTitle">Settings</span></a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="#"
                                            ><span className="withIcon"><img src={logoutwhite} alt="" /></span><span className="withTitle">Log out</span></a>
                                        </li>
                                    </ul> 
                                </div>
                            </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="component-area">
                    {isLoading && (
                        <div id='preloader'>

                            <img src={loadingGIF} alt="" />
                        </div>
                    )}
                    <Sidebar
                        IsThumbnailPresent={isThumbnailPresent}
                        CompanyId={companyId}
                    />
                    {/* <GetDocuments /> */}
                    <div className="pt-96 pb-96 my-container active-cont">
                        <div className="container mw-100 pt-30">
                            <div className="row g-0 mr-178">
                                {isLoading ? (
                                    <div className="text-center w-100">
                                    </div>
                                ) : searchBookings.length === 0 ? (
                                    <div className=" col-12 w-100">
                                        <h2 className="module-title mb-3">{t("react_employee_roles")}</h2>
                                        <div className='text-center py-5 my-5'><img src={NoData} alt="No data" />
                                        <p className='mt-3'>{t("react_no_bookings_match_selected_roles")}</p>
                                        <img
                                            src={expandedLogoUrl || logo}
                                            alt="Company logo"
                                            className="img-fluid mt-2"
                                            style={{ maxWidth: "220px" }}
                                            onError={(event) => {
                                                event.currentTarget.onerror = null;
                                                event.currentTarget.src = logo;
                                            }}
                                        />
                                        </div>
                                        
                                    </div>
                                ) : (
                                    <div >
                                        <h2 className="module-title mb-5">{t("react_employee_roles")}</h2>
                                        <div className="row">
                                            {searchBookings.map((groupedBooking) => {

                                                const firstBooking = groupedBooking?.bookings?.[0];
                                                if (!firstBooking) return null;

                                                const uniqueKey = `${firstBooking.UserId}-${firstBooking.BookingDate}-${firstBooking.ZoneId}-${firstBooking.SpotId}`;

                                                const roles = groupedBooking?.roles ?? [];
                                                const primaryRole = roles[0];
                                                const extraRolesCount = roles.length > 1 ? roles.length - 1 : 0;

                                                return (
                                                    <div className="col-md-4 mb-4" key={uniqueKey}>
                                                        <div className="role-boxes">

                                                            {/* MAP Icon */}
                                                            {(firstBooking.MapExist === 1 && firstBooking.UserZoneOccupied === 1) && (
                                                                <a className="role-icon"
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        GotoMapClick(
                                                                            firstBooking.ZoneId,
                                                                            firstBooking.BookingDate,
                                                                            firstBooking.MapType,
                                                                            firstBooking.MapExist
                                                                        );
                                                                    }}>
                                                                    <img src={WhiteLocation} alt="" />
                                                                </a>
                                                            )}

                                                            {/* Employee Name */}
                                                            <div className="emp-name">
                                                                <h3>{groupedBooking.name}</h3>
                                                            </div>

                                                            {/* Date + Zone */}
                                                            <div className="emp-place-info">
                                                                <div className="selected-current-date">
                                                                    <span>
                                                                        {(() => {
                                                                            const bookingDate = new Date(firstBooking.BookingDate);
                                                                            // Irish ("ga") has no Intl data, so toLocaleDateString
                                                                            // falls back to English ("15 JUN"). Build "DD MMM" from
                                                                            // the app's own i18n month key for Irish only; every other
                                                                            // language keeps its working Intl output.
                                                                            if ((i18n.language || "").split("-")[0] === "ga") {
                                                                                const day = String(bookingDate.getDate()).padStart(2, "0");
                                                                                const englishMonth = new Intl.DateTimeFormat("en-US", { month: "long" })
                                                                                    .format(bookingDate)
                                                                                    .toLowerCase();
                                                                                return `${day} ${t(`month_3digit_of_${englishMonth}`)}`.toUpperCase();
                                                                            }
                                                                            return bookingDate
                                                                                .toLocaleDateString(i18n.language || "en-GB", {
                                                                                    day: "2-digit",
                                                                                    month: "short"
                                                                                })
                                                                                .toUpperCase();
                                                                        })()}
                                                                    </span>

                                                                    <span>
                                                                        <span className="color-green">
                                                                            {firstBooking.SpotName}
                                                                        </span>{" "}
                                                                        {firstBooking.ZoneName}
                                                                    </span>
                                                                </div>
                                                                {firstBooking.StartTime && firstBooking.EndTime && (
                                                                    <div
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            fontWeight: 600,
                                                                            lineHeight: "18px",
                                                                            color: "var(--color-gray)",
                                                                            marginTop: "6px",
                                                                        }}
                                                                    >
                                                                        {firstBooking.StartTime} - {firstBooking.EndTime}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Roles Section */}
                                                            <div className="role-area-wrapper">

                                                                {/* Primary Role */}
                                                                {primaryRole && (
                                                                    <div className="role-area">
                                                                        <img src={primaryRole?.IconImage} alt="" />
                                                                        <p>{primaryRole.Name}</p>

                                                                        {extraRolesCount > 0 && (
                                                                            <a href="#" className="green-outline-badge">
                                                                                <span>+{extraRolesCount}</span>
                                                                                {/* Role List */}
                                                                                <div className="list-container">
                                                                                    <ul>
                                                                                        {roles.map((role) => (
                                                                                            <li key={role.Id}>
                                                                                                <img
                                                                                                    src={role.IconImage}
                                                                                                    alt=""
                                                                                                    className="img-fluid"
                                                                                                />
                                                                                                <span>{role.Name}</span>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                )}


                                                            </div>

                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderApiUi(isLoading)}
        </div>
    )
}
